<template>
  <div id="contact" class="con">
    <navheader></navheader>
    <fixheader></fixheader>
    <div class="our_contact"></div>
    <div class="container" style="max-width: 1024px !important;">
      <el-row :gutter="50">
      </el-row>
      <div class="block">
        <div class="recruit">
          <el-row :gutter="50">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="organ mess">
                <el-link :underline="false">联系我们</el-link>
                <!-- <p style="font-size: 22px !important; font-weight: bolder;">CONTACT US</p> -->
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="50" style="padding: 0 20px;">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h3 style="margin-top: 20px;">联系方式<span><!-- Contact us --></span></h3>
              <div class="contact cont">
                <h4>河北国超信息科技有限公司（总公司）</h4>
                <p class="cont-mes">我们河北国超信息科技有限公司始终坚持“赋予信息以高质量”这一企业理念，始终贯彻“高质量、快速度、低成本、客户满意”这一经营方针和“诚实、努力、虚心”这一用人原则，始终站在客户的立场以崭新的创意和灵活的构思为客户提供专业优质的服务。创造性的提升客户的商品品牌和价值，我们愿成为众多企业喜忧与共、并肩战斗的伙伴</p>
                <div style="margin-top: 30px;">
                  <p class="cont-mes">电 话: (0311)83308230/87375060/15830696619</p>
                  <p class="cont-mes">传 真: (0311)87375066</p>
                  <p class="cont-mes">邮 箱: caoyanshuang@hbguochao.com</p>
                  <p class="cont-mes">地 址: 河北省辛集市龙泉街西段9号</p>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <h3 style="margin-top: 20px;">留言板<span><!-- Message Board --></span></h3>
              <div class="container cont-bord">
                <div class="organ" style="margin-top: 10px !important;">
                  <div class="content">
                    <el-row :gutter="20">
                      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <el-input placeholder="您的姓名或公司名称" v-model="name" id="name" clearable>
                        </el-input>
                      </el-col>
                      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <el-input prop="email" placeholder="您的邮箱地址" v-model="email" id="email" clearable>
                        </el-input>
                      </el-col>
                    </el-row>
                    <el-row :gutter="20">
                      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <el-input placeholder="您的主要意向" v-model="content" id="content" clearable>
                        </el-input>
                      </el-col>
                      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <el-input placeholder="您的联系电话" v-model="phone" id="phone" clearable>
                        </el-input>
                      </el-col>
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-input type="textarea" :rows="2" placeholder="您的其它信息" v-model="other" id="other" clearable>
                        </el-input>
                      </el-col>
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <div class="more-about">
                          <el-button type="primary" id="submit" @click="sendContact()" :loading="loading">{{send}}</el-button>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="50" style="padding: 0 20px;">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div style="border: 1px solid rgba(0,0,0,0.5);margin: 30px 0;">
                <baidu-map class="map" :center="{lng: 115.221632, lat: 37.930621}" :zoom="19" :scroll-wheel-zoom="true" style="height: 500px;">
                  <bm-marker :position="{lng: 115.221632, lat: 37.930621}" :dragging="true">
                  </bm-marker>
                  <bm-info-window :position="{lng: 115.221641, lat: 37.930674}" title="河北国超信息科技有限公司" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen">
                    <p v-text="infoWindow.contents"></p>
                  </bm-info-window>
                </baidu-map>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="organ mess">
                <el-link :underline="false">更多联系方式</el-link>
                <!-- <p style="font-size: 22px !important; font-weight: bolder;">MORE CONTACT INFORMATION</p> -->
              </div>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row :gutter="50" style="padding: 0 20px;">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="contact cont more-cont">
                <h4>广州国超森茂森信息科技有限公司</h4>
                <div>
                  <p class="cont-mes">电 话: +86-020-8981-1917</p>
                  <p class="cont-mes">传 真: +86-020-8981-1443</p>
                  <p class="cont-mes">地 址: 广东省广州市天河区体育西路109号高盛大厦8楼B1室</p>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="contact cont more-cont">
                <h4>广州国超森茂森信息科技有限公司北京分公司</h4>
                <div>
                  <p class="cont-mes">电 话: 010-5870-0450</p>
                  <p class="cont-mes">邮 箱: lihuafeng@gcmc.net.cn</p>
                  <p class="cont-mes">地 址: 北京市朝阳区东大桥路8号尚都国际中心2106室</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="50" style="padding: 0 20px;margin-bottom: 50px;">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="contact cont more-cont">
                <h4>芜湖分公司</h4>
                <div>
                  <p class="cont-mes">电 话: 15178537702</p>
                  <div>
                    <div style="display: flex;">
                      <p class="cont-mes" style="width: 40px;">地址:</p>
                      <p class="cont-mes">芜湖经济技术开发区科创中心A园508</p>
                    </div>
                    <div style="display: flex;">
                      <p style="width: 40px;" class="cont-mes"></p>
                      <p class="cont-mes">芜湖瑞丰商博城M区4栋112-115</p>
                    </div>
                    <div style="display: flex;">
                      <p style="width: 40px;" class="cont-mes"></p>
                      <p class="cont-mes">奇瑞采购中心内</p>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <filing></filing>
  </div>
</template>

<script>
  import navheader from '@/components/Navheader.vue'
  import fixheader from '@/components/Fixheader.vue'
  import filing from '@/components/Filing.vue'
  export default {
    name: 'news',
    components: {
      navheader,
      fixheader,
      filing
    },
    data() {
      return {
        name: '',
        email: '',
        content: '',
        phone: '',
        other: '',
        loading: false,
        send: '提交留言',
        infoWindow: {
          show: true,
          contents: ''
        }
      }
    },
    mounted: function() {
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
      })
    },
    methods: {
      infoWindowClose(e) {
        this.infoWindow.show = false
      },
      infoWindowOpen(e) {
        this.infoWindow.show = true
      },
      clear() {
        this.infoWindow.contents = ''
      },
      sendContact: function() {
        var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        if (this.email != '' && !regEmail.test(this.email)) {
          this.$alert('邮箱格式不正确');
          return
        }
        if (this.name == "") {
          this.$alert('请填写您的姓名或公司名称');
          return
        }
        if (this.phone != "" && !(/^((0\d{2,3})-)?(\d{7,8})(-(\d{3,4}))?$/.test(this.phone)) && !(/^1[34578]\d{9}$/.test(
            this.phone))) {
          this.$alert('请正确填写您的联系电话');
          return;
        }
        if (this.phone == "") {
          this.$alert('请填写您的联系电话');
          return
        }
        this.loading = true;
        this.send = "正在提交";
        let _this = this;
        this.axios.get(this.$http + "api/index/getNews", {
            params: {
              name: this.name,
              email: this.email,
              content: this.content,
              phone: this.phone,
              other: this.other
            }
          })
          .then((res) => {
            setTimeout(function() {
              _this.loading = false
              _this.send = "提交成功"
              _this.name = ""
              _this.email = ""
              _this.intention = ""
              _this.phone = ""
              _this.message = ""
            }, 1000)
            setTimeout(function() {
              _this.send = "提交/Submit"
            }, 2000)
          })
          .catch((err) => {})
      }
    }
  }
</script>

<style>
  .title-color,
  .content-news {
    color: #606266;
  }

  #contact .recruit .organ {
    margin: 50px 0 0 0;
  }

  #contact div.el-divider {
    height: 3px !important;
    position: relative;
  }

  #contact div.el-divider:before {
    position: absolute;
    content: "";
    top: 0;
    width: 160px;
    height: 3px;
    background-color: rgba(0, 0, 0, 0.6);
    right: calc(50% - 80px);
  }

  #contact h3 {
    width: 100%;
    text-align: left;
    color: #5cb6ff !important;
  }

  #contact .contract-con {
    color: rgba(0, 0, 0, 0.7) !important;
    font-size: 14px;
    font-weight: bolder;
  }

  #contact h4 {
    color: rgba(0, 0, 0, 0.7);
    margin: 20px 0;
  }

  #contact .more-cont h4 {
    margin: 20px 0 5px 0;
    color: #5cb6ff;
  }

  #contact p.cont-mes {
    font-size: 14px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.7);
    line-height: 24px;
  }

  #contact .cont {
    background: transparent !important;
  }

  #contact .cont::before {
    background-color: transparent !important;
  }

  #contact .cont input,
  #contact .cont textarea {
    border: 1px solid rgba(0, 0, 0, 0.7);
    color: rgb(0, 0, 0, 0.7) !important;
  }

  #contact .organ .el-row .el-col {
    margin-top: 11px;
    margin-bottom: 11px;
  }

  #contact input::-webkit-input-placeholder {
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact input::-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact textarea::-webkit-input-placeholder {
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact textarea::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact textarea:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact textarea::-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #000 !important;
    font-weight: bolder !important;
  }

  #contact textarea {
    font-size: 14px;
    /* font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif; */
  }

  #contact .cont-bord {
    padding: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/content/Our_contact.vue